import {Pipe, PipeTransform} from '@angular/core';
import {S3Object} from '../../models';
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({
    name: 's3Link'
})
export class S3LinkPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
    constructor(protected _sanitizer: DomSanitizer) {
    }

    transform(value: S3Object, type?: string): any {
        if (!value)
            return 'assets/imgs/user.jpg';
        const link = 'https://' + value.bucket + '.s3.' + value.region + '.amazonaws.com/public/' + value.key;
        switch (type) {
            case 'html':
                return this._sanitizer.bypassSecurityTrustHtml(link);
            case 'style':
                return this._sanitizer.bypassSecurityTrustStyle(link);
            case 'script':
                return this._sanitizer.bypassSecurityTrustScript(link);
            case 'url':
                return this._sanitizer.bypassSecurityTrustUrl(link);
            case 'resourceUrl':
                return this._sanitizer.bypassSecurityTrustResourceUrl(link);
            default:
                return link
        }
    }

}
